import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconColumn = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M10.5 5.5C10.5 5.91421 10.1642 6.25 9.75 6.25H3.75C3.33579 6.25 3 5.91421 3 5.5C3 5.08579 3.33579 4.75 3.75 4.75H9.75C10.1642 4.75 10.5 5.08579 10.5 5.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.5 18.5C10.5 18.9142 10.1642 19.25 9.75 19.25H3.75C3.33579 19.25 3 18.9142 3 18.5C3 18.0858 3.33579 17.75 3.75 17.75H9.75C10.1642 17.75 10.5 18.0858 10.5 18.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.5 12C10.5 12.4142 10.1642 12.75 9.75 12.75H3.75C3.33579 12.75 3 12.4142 3 12C3 11.5858 3.33579 11.25 3.75 11.25H9.75C10.1642 11.25 10.5 11.5858 10.5 12Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21 5.5C21 5.91421 20.6642 6.25 20.25 6.25H14.25C13.8358 6.25 13.5 5.91421 13.5 5.5C13.5 5.08579 13.8358 4.75 14.25 4.75H20.25C20.6642 4.75 21 5.08579 21 5.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21 18.5C21 18.9142 20.6642 19.25 20.25 19.25H14.25C13.8358 19.25 13.5 18.9142 13.5 18.5C13.5 18.0858 13.8358 17.75 14.25 17.75H20.25C20.6642 17.75 21 18.0858 21 18.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21 12C21 12.4142 20.6642 12.75 20.25 12.75H14.25C13.8358 12.75 13.5 12.4142 13.5 12C13.5 11.5858 13.8358 11.25 14.25 11.25H20.25C20.6642 11.25 21 11.5858 21 12Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconColumn as ReactComponent };
